import { RouteRecordRaw } from 'vue-router';
import { layoutAreaTypes } from '@/types/layoutTypes';

const errorRoutes: Array<RouteRecordRaw> = [
  {
    path: '/:notFound',
    name: 'Error: 404 Page Not Found',
    component: () =>
      import(/* webpackChunkName: "home" */ '@/views/errorArea/Error404NotFoundPage.vue'),
    meta: { layout: layoutAreaTypes.Unlogged },
  },
  {
    path: '/error/duplicatedusername',
    name: 'Error: duplicated username',
    component: () =>
      import(/* webpackChunkName: "home" */ '@/views/errorArea/ErrorDuplicatedUsername.vue'),
    meta: { layout: layoutAreaTypes.Unlogged },
  },
  {
    path: '/error/accessdenied',
    name: 'Error: Access denied',
    component: () =>
      import(/* webpackChunkName: "home" */ '@/views/errorArea/ErrorAccessDenied.vue'),
    meta: { layout: layoutAreaTypes.Unlogged },
  },
  {
    path: '/error/commonerrorpage',
    name: 'Error: Commom error',
    component: () =>
      import(/* webpackChunkName: "home" */ '@/views/errorArea/ErrorCommonErrorPage.vue'),
    meta: { layout: layoutAreaTypes.Unlogged },
  },
];

export default errorRoutes;
